export default function refreshSite() {
  const pathname = (window.location.pathname || '').slice(1);
  const restrictedURLs = ['404', 'error', 'logout'];
  if (restrictedURLs.indexOf(pathname) === -1) {
    window.location.reload();
  } else {
    window.location.href = '/';
  }
}
